import { ConfigSchema } from "./configTypes";
import { formatAttr } from "./configModel";
import { NameMode, primaryName, Vehicle } from "./data";

/**
 * Whether a tractor matches a free-text query.
 *
 * Tested against exactly what the table renders — the (mode-aware) name, the
 * operational state, and every config value as `formatAttr` shows it — so a
 * match means "this string is visible on the row." Case-insensitive substring;
 * an empty query matches everything.
 *
 * Lives here rather than inside the table so FleetView can own one query, drive
 * both the search box and the "N of M" count from it, and keep the table a pure
 * sort/render component (SW-6323).
 */
export function matchesQuery(
  vehicle: Vehicle,
  schema: ConfigSchema | null,
  nameMode: NameMode,
  query: string,
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  const haystack = [
    primaryName(vehicle, nameMode),
    vehicle.operationalState ?? "",
    ...(schema?.fields ?? []).map((f) =>
      formatAttr(f, vehicle.attrs[f.name] ?? null),
    ),
  ]
    .join(" ")
    .toLowerCase();
  return haystack.includes(needle);
}
